import React from 'react';

export default function ImageRecommendations({
  images,
  isLandscape,
  landscapeWidth,
  portraitWidth,
}) {
  return (
    <div className="skincaredetectionpreview-results__recommend-container">
      {images.map((src, i) => (
        <img
          key={i}
          style={{
            width: isLandscape ? landscapeWidth : portraitWidth,
            marginRight: isLandscape ? '10px' : '3px',
          }}
          alt=""
          src={src}
        />
      ))}
    </div>
  );
}
